import { createTheme } from "@mui/material/styles";
import palette from "./palette.scss";

export const theme = createTheme({
  palette: {
    primary: {
      light: palette.primary_light,
      main: palette.primary_main,
      dark: palette.primary_dark,
      contrastText: palette.primary_contrastText,
    },
    secondary: {
      light: palette.secondary_light,
      main: palette.secondary_main,
      dark: palette.secondary_dark,
      contrastText: palette.secondary_contrastText,
    },
  },
});
